import { Injectable } from '@angular/core';

import amplitude from 'amplitude-js';

import { environment } from '@env/environment';

import { AmplitudeAbstractService } from './amplitude.abstract.service';

type AmplitudeErrorDetails = {
  reason?: string;
};

@Injectable()
export class AmplitudeBrowserService extends AmplitudeAbstractService {
  init(): void {
    amplitude.getInstance().init(environment.AMPLITUDE_API_KEY, null, {
      includeUtm: true,
      includeReferrer: true,
      includeGclid: true,
      includeFbclid: true,
    });
  }

  setItem(key: string, val: any): void {
    const identify = new amplitude.Identify().set(key, val);
    amplitude.getInstance().identify(identify);
  }

  logEvent(
    name: string,
    data: Record<string, unknown>,
    onSuccess: () => void,
    onError: (message?: string) => void,
  ): void {
    this.init();

    // Redirect flows need a completion callback so we can avoid losing the event.
    amplitude.getInstance().logEvent(
      name,
      data,
      (responseCode: number, responseBody: string) => {
        if (responseCode === 200) {
          onSuccess();
          return;
        }

        onError(responseBody || 'Amplitude did not confirm the event.');
      },
      (
        responseCode: number,
        responseBody: string,
        details?: AmplitudeErrorDetails,
      ) => {
        onError(
          details?.reason ||
            responseBody ||
            `Amplitude request failed with code ${responseCode}.`,
        );
      },
    );
  }

  setItems(list: Array<{ key: string; val: any }>): void {
    let identify = new amplitude.Identify();
    for (const item of list) {
      identify = identify.set(item.key, item.val);
    }
    amplitude.getInstance().identify(identify);
  }

  unsetItem(key: string): void {
    const identify = new amplitude.Identify().unset(key);
    amplitude.getInstance().identify(identify);
  }

  logEventWithTimestamp(name: string, data: any): void {
    amplitude.getInstance().logEventWithTimestamp(name, data);
  }
}
